import axios from '../utils/axios';

export default function getCompaniesWithPendingLogos (adminId, params) {
    return axios.get(`/admin/${adminId}/getCompanyDetailsWithPendingLogos`, { params });
}